module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARpJREFUOE+tlGESgiAQhd/WVBfyf3ihmk6gnqCpC2n/vVA2SQOI0IZATf51ebz9dh+EP38U0ysu97o/7upv7lwUVGIAVRip7E+bLldUC86Hc09FLjGC54fAahSLekR7SAgQOkh5i2GIMrQX2A764zZZ/1Gg3QLwuRWXQQKyyRnQp+B1aFV71o3j+6ug5ilbxas/bEvjDshpV9UFmRSTSzMECL/dlOPIHhpnnJ11rH8F1ifs0LbNBGd31vmExV+38JQVw0kMRHvF0gTATXvGwly+Cb4lhhVydiYMbnjWpUvKWlZzGp7U8Pxqd1NSXItUcZYsy+FdS2bdY5mMEmfH885ZJgVTe8dZ5gmOqy72JppLVZp2dVIw94m0dS+V8M0VBCdRUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_language.png
// module id = mGrL
// module chunks = 1